import { toast } from "sonner";

export const STATE = {
  healthy: { label: "Healthy", badge: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300 border-emerald-500/30", dot: "bg-emerald-500", ring: "border-emerald-500/30" },
  warning: { label: "Warning", badge: "bg-amber-500/15 text-amber-700 dark:text-amber-300 border-amber-500/30", dot: "bg-amber-500", ring: "border-amber-500/40" },
  critical: { label: "Critical Issue", badge: "bg-rose-500/15 text-rose-700 dark:text-rose-300 border-rose-500/30", dot: "bg-rose-500", ring: "border-rose-500/50" },
  monitoring_problem: { label: "Health Data May Be Stale", badge: "bg-slate-500/15 text-slate-700 dark:text-slate-200 border-slate-500/30", dot: "bg-slate-400", ring: "border-slate-400/50" },
};

export const SEVERITY = {
  critical: "bg-rose-500/15 text-rose-700 dark:text-rose-300 border-rose-500/30",
  warning: "bg-amber-500/15 text-amber-700 dark:text-amber-300 border-amber-500/30",
};

export const fmt = (iso) => (iso ? new Date(iso).toLocaleString([], { dateStyle: "medium", timeStyle: "short" }) : "—");

export const copyText = async (text, what = "Report") => {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(`${what} copied to clipboard`);
  } catch {
    toast.error("Could not copy — your browser blocked clipboard access");
  }
};
